import Config from 'Config';
import aws4 from 'aws4';

/**
 * Used to set filepermissions to the database
 * @param {array} filePermissions array of filePermission objects
 * @param {*} params 
 * @returns array of created filePermissions
 */
export default async function setFilePermissions(filePermissions, params) {
    const apiPath = `create-file-permissions`;

    const request = {
        host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
        path: apiPath,
        method: 'POST',
        region: Config.AWS_REGION,
        service: 'execute-api',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(filePermissions),
    };
    const signer = new aws4.RequestSigner(request, {
        accessKeyId: params.accessKeyId,
        secretAccessKey: params.secretAccessKey,
        sessionToken: params.sessionToken,
    });
    const signedRequest = signer.sign();
    signedRequest.headers.Accept = '*/*';

    const response = await fetch(
        `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
        // `http://localhost:3001/${apiPath}`,
        signedRequest
    ).then((res) => res.json());
    return response;
}